<template>
  <a :href="link" target="_blank" class="icon-button">
    <img src="@/assets/icons/facebook.svg" class="icon-button__icon" />
    <span class="icon-button__label">{{ label }}</span>
  </a>
</template>

<script>
export default {
  name: "IconButton",
  props: {
    label: {
      type: String,
      default: undefined
    },
    link: {
      type: String,
      default: "#"
    }
  }
};
</script>

<style lang="scss" scoped>
.icon-button {
  align-items: center;
  border-radius: sizes("border-radius-s");
  display: flex;
  font-size: px-to-rem(18px);
  padding: spacer("s");
  position: relative;
  text-decoration: none;
  transition: cta-transition(background-color, 0.3s);

  &__icon {
    height: 20px;
    margin-right: spacer("s");
  }

  &__label {
    color: theme-color("body");
    display: block;
  }

  &:hover {
    background-color: rgba(theme-color("body"), 0.2);
  }
}
</style>
